<template>
    <div class="DocumentKnowledgeBaseBox">
        <doc-page ref='docPage' :moduleCode='moduleCode' :rootFolderId="rootFolderId" :rootFolderName="rootFolderName" :folderSource="folderSource" class="DocumentKnowledgeBase"></doc-page>
    </div>
</template>

<script>
import DocPage from '../Vue/DocPage/index'
import titleMixin from '@/mixin/title'
export default {
    name: 'My',
    mixins: [titleMixin],
    title: function fc() { return this.$t('mx_mobile.Doc.1585191556548') }, // '知识库'
    data() {
        return {
            moduleCode: 'DC001',
            rootFolderId: 1,
            rootFolderName: this.$t('mx_mobile.Doc.1585191556548'), // '知识库'
            folderSource: 1
        }
    },
    created() { },

    mounted() { },
    methods: {},
    beforeRouteLeave(to, from, next) {
        this.$refs.docPage.beforeLeave(to, from, next)
    },
    watch: {
        $route(to, from) {
            if (this.$route.path == '/document/knowledgebase') {
                this.$refs.docPage.setMenu()
                this.$refs.docPage.reGetList()
            }
        }
    },
    components: {
        'doc-page': DocPage
    }
}
</script>

<style lang='less' rel='stylesheet/less' scoped>
@import "./zh-cn.less";
@import "./en.less";
</style>
